import 'choerodon-ui/lib/spin/style';
